import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_button = _resolveComponent("k-button")!
  const _component_button_group = _resolveComponent("button-group")!

  return (_openBlock(), _createBlock(_component_button_group, { rounded: "full" }, {
    default: _withCtx(() => [
      (_ctx.item.materialNo)
        ? (_openBlock(), _createBlock(_component_k_button, {
            key: 0,
            icon: "zoom",
            title: _ctx.localize('details'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDetails(_ctx.item)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.getPictureIndicatorClasses(_ctx.item)),
                style: {"align-self":"flex-start"}
              }, null, 2),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.getPdfFileIndicatorClasses(_ctx.item)),
                style: {"align-self":"flex-start"}
              }, null, 2)
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      (_ctx.showProductionBomButton)
        ? (_openBlock(), _createBlock(_component_k_button, {
            key: 1,
            "image-url": _ctx.iconPathProduction,
            class: "background-production-items",
            title: _ctx.localizeBomItemText('BOMitems_Production'),
            disabled: _ctx.productionBomButtonDisabled,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleProductionNode(_ctx.item)))
          }, null, 8, ["image-url", "title", "disabled"]))
        : _createCommentVNode("", true),
      (_ctx.showAlternativeBomNodeButton)
        ? (_openBlock(), _createBlock(_component_k_button, {
            key: 2,
            "image-url": _ctx.iconPathAlternativeBom,
            class: "background-alternative-bom",
            title: _ctx.localize('AllOptions'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleAlternativeBomNode(_ctx.item)))
          }, null, 8, ["image-url", "title"]))
        : _createCommentVNode("", true),
      (_ctx.showReplacementButton)
        ? (_openBlock(), _createBlock(_component_k_button, {
            key: 3,
            "image-url": _ctx.iconPathReplaced,
            class: "background-replacement-items",
            title: _ctx.localize('Replacement'),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleReplacementNode(_ctx.item)))
          }, null, 8, ["image-url", "title"]))
        : _createCommentVNode("", true),
      (_ctx.showRecommendedItemsButton)
        ? (_openBlock(), _createBlock(_component_k_button, {
            key: 4,
            "image-url": _ctx.iconPathBoughtTogether,
            class: "background-recommended-items",
            title: _ctx.localizeBomItemText('BOMitems_Recommended'),
            disabled: _ctx.recommendedItemsButtonDisabled,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleBoughtWithNode(_ctx.item)))
          }, null, 8, ["image-url", "title", "disabled"]))
        : _createCommentVNode("", true),
      (_ctx.showMaintenanceBomButton)
        ? (_openBlock(), _createBlock(_component_k_button, {
            key: 5,
            "image-url": _ctx.iconPathMaintenance,
            class: "background-maintenance-items",
            title: _ctx.localizeBomItemText('BOMitems_Maintenance'),
            disabled: _ctx.maintenanceBomButtonDisabled,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleMaintenanceNode(_ctx.item)))
          }, null, 8, ["image-url", "title", "disabled"]))
        : _createCommentVNode("", true),
      (_ctx.showAlternativeItemsButton)
        ? (_openBlock(), _createBlock(_component_k_button, {
            key: 6,
            "image-url": _ctx.iconPathAlternativeItems,
            class: "background-alternative-items",
            title: _ctx.localizeBomItemText('BOMitems_Alternatives'),
            disabled: _ctx.alternativeItemsButtonDisabled,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleAlternativeItemsNode(_ctx.item)))
          }, null, 8, ["image-url", "title", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}